<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <div class="px-4 sm:px-[26%] pt-[100px] text-justify text-sm sm:text-base relative z-10">
        <h1 class="font-bold text-center text-5xl sm:text-9xl font-outfit mb-8">
            Privacy Policy
        </h1>
        <div class="mb-8">
            This privacy policy has been compiled to serve better those who are concerned with how their 'Personally
            Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information
            security, is information that can be used on its own or with other information to identify, contact, or
            locate a single person or to identify an individual in context. Please read our privacy policy carefully to
            get a clear understanding of how we collect, use, protect or otherwise handle your Personally Identifiable
            Information in accordance with our website.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            What personal information do we collect from the people that visit our blog, website or app?
        </div>
        <div class="mb-8">
            When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address
            or other details to help you with your experience.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            When do we collect information?
        </div>
        <div class="mb-8">
            We collect information from you when you fill out a form or enter information on our site.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            How do we use your information?
        </div>
        <div class="mb-8">
            We may use the information we collect from you when you register, make a purchase, sign up for our
            newsletter, respond to a survey or marketing communication, surf the website, or use certain other site
            features in the following ways:
            <ul class="list-disc pl-8 mt-4">
                <li>
                    To follow up with them after correspondence (live chat, email or phone inquiries)
                </li>
            </ul>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            How do we protect your information?
        </div>
        <div class="mb-8">
            <p class="mb-4">
                Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make
                your visit
                to our site as safe as possible.
            </p>
            <p class="mb-4">
                We use regular Malware Scanning.
            </p>
            <p class="mb-4">Your personal information is contained behind secured networks and is only accessible by a
                limited number of persons
                who have special access rights to such systems, and are required to keep the information confidential.
                In addition,
                all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology.</p>
            <p class="mb-4">
                We implement a variety of security measures when a user enters, submits, or accesses their information
                to maintain
                the safety of your personal information.
            </p>
            <p class="mb-4">
                All transactions are processed through a gateway provider and are not stored or processed on our
                servers.
            </p>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Do we use 'cookies'?
        </div>
        <div class="mb-8">
            <p class="mb-4">
                We do not use cookies for tracking purposes
                You can choose to have your computer warn you each time a cookie is being sent, or you can choose to
                turn off
                all
                cookies. You do this through your browser settings. Since browser is a little different, look at your
                browser's
                Help
                Menu to learn the correct way to modify your cookies.
            </p>
            <p class="mb-4">
                If you turn cookies off, Some of the features that make your site experience more efficient may not
                function
                properly.that make your site experience more efficient and may not function properly.
            </p>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Third-party disclosure
        </div>
        <div class="mb-8">
            We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Third-party links
        </div>
        <div class="mb-8">
            We do not include or offer third-party products or services on our website.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Google
        </div>
        <div class="mb-8">
            <p class="mb-4">
                Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in
                place to
                provide a positive experience for users. <a class="text-[#7E47F3]"
                    href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">https://support.google.com/adwordspolicy/answer/1316548?hl=en</a>
            </p>
            <p class="mb-4">
                We use Google AdSense Advertising on our website.
                Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie
                enables
                it
                to serve ads to our users based on previous visits to our site and other sites on the Internet. Users
                may
                opt-out of
                the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.
            </p>
            <div class="mb-4">
                We have implemented the following:
                <ul class="list-disc pl-8 mt-4">
                    <li>
                        Remarketing with Google AdSense
                    </li>
                    <li>
                        Google Display Network Impression Reporting
                    </li>
                </ul>
                We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics
                cookies)
                and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to
                compile data
                regarding user interactions with ad impressions and other ad service functions as they relate to our
                website.
            </div>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Opting out:
        </div>
        <div class="mb-8">
            Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively,
            you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics
            Opt Out Browser add on.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            California Online Privacy Protection Act
        </div>
        <div class="mb-8">
            <p class="mb-4">
                CalOPPA is the first state law in the nation to require commercial websites and online services to post
                a
                privacy policy. The law's reach stretches well beyond California to require any person or company in the
                United
                States (and conceivably the world) that operates websites collecting Personally Identifiable Information
                from
                California consumers to post a conspicuous privacy policy on its website stating exactly the information
                being
                collected and those individuals or companies with whom it is being shared. - See more at:
                <a class="text-[#7E47F3]"
                    href="https://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf">
                    https://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
                </a>
            </p>
            <div class="mb-4">
                According to CalOPPA, we agree to the following:
                <ul class="list-disc pl-8 mt-4">
                    <li>
                        Users can visit our site anonymously.
                    </li>
                    <li>
                        Once this privacy policy is created, we will add a link to it on our home page or as a minimum,
                        on the first significant page after entering our website.
                    </li>
                    <li>
                        Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page
                        specified above.
                    </li>
                    <li>
                        You will be notified of any Privacy Policy changes on our Privacy Policy Page.
                    </li>
                    <li>
                        You can change your personal information by emailing us.
                    </li>
                </ul>
            </div>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            How does our site handle Do Not Track signals?
        </div>
        <div class="mb-8">
            We don't honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track
            (DNT)
            browser mechanism is in place. We don't honor them because:
            <ul class="list-disc pl-8 mt-4">
                <li>
                    We need all user data
                </li>
            </ul>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Does our site allow third-party behavioral tracking?
        </div>
        <div class="mb-8">
            It's also important to note that we allow third-party behavioral tracking.
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            COPPA (Children Online Privacy Protection Act)
        </div>
        <div class="mb-8">
            <p class="mb-4">
                When it comes to the collection of personal information from children under the age of 13 years old, the
                Childrens Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission,
                United
                States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites
                and
                online services must do to protect children's privacy and safety online.
            </p>
            <p class="mb-4">
                We do not specifically market to children under the age of 13 years old.<br>
                Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?
            </p>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Fair Information Practices
        </div>
        <div class="mb-8">
            <p class="mb-4">
                The Fair Information Practices Principles form the backbone of privacy law in the United States and the
                concepts
                they include have played a significant role in the development of data protection laws around the globe.
                Understanding the Fair Information Practice Principles and how they should be implemented is critical to
                comply
                with
                the various privacy laws that protect personal information.
            </p>
            <div class="mb-4">
                In order to be in line with Fair Information Practices we will take the following responsive action,
                should a
                data breach occur:
                <ul class="list-disc pl-8 mt-4">
                    <li>
                        We will notify you via email
                    </li>
                    <li>
                        Within an undisclosed timeframe
                    </li>
                </ul>
                We also agree to the Individual Redress Principle which requires that individuals have the right to
                legally
                pursue enforceable rights against data collectors and processors who fail to adhere to the law. This
                principle
                requires not only that individuals have enforceable rights against data users, but also that individuals
                have
                recourse to courts or government agencies to investigate and/or prosecute non-compliance by data
                processors.
            </div>
            <p class="mb-4">
                We do not specifically market to children under the age of 13 years old.<br>
                Do we let third-parties, including ad networks or plug-ins collect PII from children under 13?
            </p>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            CAN SPAM Act
        </div>
        <div class="mb-8">
            <p class="mb-4">
                The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for
                commercial
                messages, gives recipients the right to have emails stopped from being sent to them, and spells out
                tough
                penalties for violations.
            </p>
            <p class="mb-4">
                We collect your email address in order to send information, respond to inquiries, and/or other requests
                or
                questions
            </p>
            <div class="mb-4">
                To be in accordance with CANSPAM, we agree to the following:
                <ul class="list-disc pl-8 mt-4">
                    <li>
                        Not use false or misleading subjects or email addresses.
                    </li>
                    <li>
                        Identify the message as an advertisement in some reasonable way.
                    </li>
                    <li>
                        Include the physical address of our business or site headquarters.
                    </li>
                    <li>
                        Monitor third-party email marketing services for compliance, if one is used.
                    </li>
                    <li>
                        Honor opt-out/unsubscribe requests quickly.
                    </li>
                    <li>
                        Allow users to unsubscribe by using the link at the bottom of each email.
                    </li>
                </ul>
                If at any time you would like to unsubscribe from receiving future emails, you can email us at <a
                    class="text-[#7E47F3]" href="mailto:mike@semnexus.com">mike&#64;semnexus.com</a>
                and we will promptly remove you from ALL correspondence.
            </div>
        </div>
        <div class="font-bold text-2xl font-outfit mb-8">
            Contacting Us
        </div>
        <div class="mb-8">
            <p class="mb-4">
                If there are any questions regarding this privacy policy, you may contact us using the information
                below.
            </p>
            <p class="mb-4">
                <a class="text-[#7E47F3]" href="/">semnexus.com</a><br>
                46 Old Pond Road<br>
                Great Neck, New York 11023
            </p>
            <p class="mb-4">
                United States<br>
                <a class="text-[#7E47F3]" href="mailto:mike@semnexus.com">mike&#64;semnexus.com</a><br>
                Last Edited on 2018-04-11
            </p>
        </div>
    </div>
    <app-connect></app-connect>
</app-background>